
import { Component, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import { SalesOrder } from '@/api/model';
import { SapCustomerPartner } from '@/api/model/sap-customer-partner';
import OrderCard from '@/components/orders/OrderCard.vue';
import ShipToAddress from '@/components/orders/new-order/ShipToAddress.vue';
import Helpers from '@/logic/orders/helpers';
import NewOrderFooter from '@/components/orders/new-order/NewOrderFooter.vue';
import { DateFnsLocales } from '@/DateFnsLocales';

@Component({
  components: { ShipToAddress, OrderCard, NewOrderFooter },
})
export default class OrderSummaryAndConfirmation extends Vue {
  get cart(): SalesOrder {
    return this.$store.state.order.cart;
  }

  get shipTo(): SapCustomerPartner {
    return this.$store.state.order.shipToPartners.find(
      (p: SapCustomerPartner) => p.CustomerNr === this.cart.ShipToParty,
    );
  }

  get deliveryDate(): string | null {
    if (this.cart.ReqDlvDate === undefined || this.cart.ReqDlvDate === null) {
      return null;
    }
    const date = Helpers.getDateFromSapDate(this.cart.ReqDlvDate);
    if (date instanceof Date && !Number.isNaN(date.getDate())) {
      return format(date, 'PPP', { locale: DateFnsLocales[this.$i18n.locale] });
    }
    return null;
  }
}
